export default "__VITE_ASSET__YoNfb5$b__"